import { render, staticRenderFns } from "./OnboardingSelfieError.vue?vue&type=template&id=28341b11&scoped=true"
import script from "./OnboardingSelfieError.vue?vue&type=script&lang=js"
export * from "./OnboardingSelfieError.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSelfieError.vue?vue&type=style&index=0&id=28341b11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28341b11",
  null
  
)

export default component.exports